export const meta = {
  title: '故障排查：感觉不对劲的时候',
  updatedAt: '2026-07-17',
  related: ['faq', 'notifications', 'billing'],
};

运营者最常撞上的四件事——先说症状，再说到底该查什么。

## 顾客装不上应用

- **Android（Chrome）** —— 浏览器允许时，您的应用里会出现**安装**按钮。如果顾客关掉过浏览器自己的提示，同一会话里 Chrome 不会再给机会——关掉浏览器重开，按钮就回来了。
- **iPhone（Safari）** —— Apple 从不弹安装提示。您的应用会识别这一点，改为显示三步手动指引：打开**分享**菜单，选**添加到主屏幕**，确认。
- 无论哪种，安装都是可选的。下单、实时排队状态、付款，在普通浏览器标签页里全都能用。

## 通知收不到

按这个清单逐项查：

1. **权限** —— 顾客必须在应用询问时点过允许（应用会在下单后立刻询问）。如果点了拒绝，浏览器会记住：需要到浏览器的网站设置里重新放行——应用自己无法再问一次。
2. **iPhone** —— 只有把应用添加到主屏幕后通知才有效；普通 Safari 标签页收不到推送。
3. **预期** —— 推送只在工单进队、开洗、待取、取消、暂停时发出，外加升级祝贺。**取车时没有推送**——“收据通知”不是丢了，是本来就不存在。
4. **营销类** —— 退订和免打扰时段（默认 22:00–08:00）会静默且正确地拦下营销推送。您的群发摘要会精确点名跳过了多少、为什么。

## 付款链接过期了

两种不同情况：

- **顾客在线支付洗车费** —— 支付页设计上就是一次性、短时效的。解决办法很简单：再点一次**付款**——每次点击都会签发全新链接。被放弃的支付会自行过期，不会向任何人扣款。
- **您自己的订阅账单** —— 在账单页，用账单旁的**重新生成**拿到新的付款链接。只有最新的链接能完成结算；旧链接会被拒绝，以杜绝重复扣款的风险。

## 门店没出现在公共目录上

按顺序检查：

1. **开关** —— 营业时间页底部的*在公共目录展示我的门店*必须打开。每个新账户默认是关的。
2. **门店状态** —— 只有活跃门店才会被列出。已关停或移除的门店会自动从目录消失。
3. **时间** —— 保存后变更几秒内就会生效。怀疑卡住时，把开关关了再开，强制刷新一次。
4. **审核** —— 网络会对公共目录做人工管理，违反规则的条目可能被隐藏。如果您认为是误伤，请通过联系页写信给我们。

## 还是卡住？

**联系**页会在一个工作日内送达真人——页脚的 WhatsApp 更快。告诉我们您看到了什么、期待的是什么；有截图更好。
